import { Grid, makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import UtilService from "../../../../../helper/service";
import clsx from 'clsx';
import { apiClient } from "../../../../../config/apiClient";
import { handleCopyFile } from "../../../../../helper/stimulus";
import {
  getBraintrustListForOnboarding,
  moveNextPage,
  updateCreatorOnboarding,
  validateSessionCodeForOnboarding,
} from "../../../../../store/actions/creator/creatorOnBoarding";
import { useHistory, useLocation } from "react-router";
import {BackDropAnalyzeLoading, Loading} from '../../../../atoms/commonLoadings';
import axios from 'axios';
import Config from "../../../../../config/config";
import useWindowSize from "../../../../../helper/hooks/useWindowSize";

const useStyles = makeStyles(() => ({
  title: {
    marginTop: 10,
    textAlign: 'center',
    fontSize: (props: any) => (props.height < 770 || props.width < 1660) ? 28 : 36,
    color: '#212D40',
    fontFamily: 'Spartan-bold',
    lineHeight: 1.25,
    '@media (max-width: 600px)': {
      fontSize: '25px!important',
    },
  },
  subTitle: {
    textAlign: 'center',
    fontSize: (props: any) => (props.height < 770 || props.width < 1660) ? 24 : 30,
    color: '#212D40',
    fontFamily: 'roboto-light',
    marginTop: (props: any) => (props.height < 770 || props.width < 1660) ? 10 : 20,
    marginBottom: (props: any) => (props.height < 770 || props.width < 1660) ? 20 : 30
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: 'pointer',
    maxWidth: 'calc(50% - 20px)',
    marginLeft: 10,
    marginRight: 10,
    marginBottom: (props: any) => (props.height < 770 || props.width < 1660) ? 25 : 35,
    '@media (max-width: 600px)': {
      maxWidth: 'calc(100%)',
    },
  },
  itemTitle: {
    textAlign: 'center',
    fontFamily: 'roboto-light',
    fontSize: (props: any) => (props.height < 770 || props.width < 1660) ? 20 : 23,
    color: '#212D40',
    paddingTop: 10
  },
  img: {
    height: (props: any) => (props.height < 770 || props.width < 1660) ? 180 : 200,
    width: 'auto',
    borderRadius: 10,
  },
  youtubeHover: {
    transform: "scale3d(1.05, 1.05, 1)",
    boxShadow: '0px 2px 10px rgb(0 0 0 / 50%)'
  }
}));

const Module2Slide1 = () => {

  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const { userPreferences, braintrustList } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const [selectExperiences, setSelectExperiences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hoverIndex, setHoverIndex] = useState(-1);
  const {width} = useWindowSize();

  useEffect(() => {
    dispatch(getBraintrustListForOnboarding(apolloClient.client))
  }, []);

  useEffect(() => {
    if (braintrustList) {
      setSelectExperiences(UtilService.getPredefinedExperiences(braintrustList))
    }
  }, [braintrustList]);

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm2s1');
  }, []);

  const getSessionCode = async () => {
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
    const payload = {
      "requestor": "experience",
      "tenant_id": loginUserData.customer_id
    };
    setLoading(true);
    try {
      const res = await apiClient(false).post('/registration/v2/session/tokens', payload);
      if (res && res.data && res.data.token) {
        const checkSession = await validateSessionCodeForOnboarding(apolloClient.client, res.data.token);
        if (checkSession && checkSession.data && checkSession.data.validateSessionCode) {
          localStorage.setItem("session_code", String(res.data.token));
          return res.data.token;
        } else {
          getSessionCode();
        }
      } else {
        getSessionCode();
      }
    } catch (e) {
      return '';
    }
    return '';
  };

  const goNextPage = async (item: any) => {
    axios.post(Config.API_URL, {
      query: `query share($session_code: String!) {
          share(session_code: $session_code) {
              data
              status
              messagecode
              message
          }
      }`,
      variables: {
        session_code: item.session_code,
      }
    }, {
      headers: {
        accesstoken: localStorage.getItem("auth_token"),
        schemaname: item?.customer_name,
        idToken: localStorage.getItem("idToken")
      }
    }).then(async (result: any) => {
      if (result) {
        const uuid = result.data.data?.share?.data?.uuid;
        if (uuid) {
          const dynamicData1 = await axios.get(`${Config.CLOUD_FRONT_URL}/overview/${uuid}.json`);
          const dynamicData2 = await axios.get(`${Config.CLOUD_FRONT_URL}/analyze/${uuid}.json`);
          const request = {
            user_id: loginUserData.user_id,
            preference_id: userPreferences.module4Data.id,
            preference_name: 'MODULE4DATA',
            preference_information: JSON.stringify({ session: dynamicData1.data, analyze: dynamicData2.data }),
          };
          dispatch(updateCreatorOnboarding(apolloClient.client, request));
        }
      } else {

      }
    }).catch(() => {

    });

    const request = {
      user_id: loginUserData.user_id,
      preference_id: userPreferences.youtube.id,
      preference_name: 'ONBOARDING_YOUTUBE',
      preference_information: JSON.stringify({
        url: item.url,
        thumbnail: item.thumbnail
      }),
    };

    dispatch(updateCreatorOnboarding(apolloClient.client, request));

    const fetchedSessionCode = await getSessionCode();
    const videoInfo: any = {};
    if (fetchedSessionCode) {
      videoInfo['sessionCode'] = fetchedSessionCode;
      if (item.braintrust_id) {
        const payload = {
          source_session_code: item.session_code,
          source_tenant_id: item.customer_id,
          target_session_code: fetchedSessionCode,
          target_tenant_id: loginUserData.customer_id,
          created_by: loginUserData.username
        };
        await apiClient(true).post('/stimulus/v2/stimulus/copy', payload);
        videoInfo['braintrust'] = item;
        if (item.session_started_at && item.session_ended_at) {
          videoInfo['difference'] = parseInt(item.session_ended_at) - parseInt(item.session_started_at);
        }
      } else {
        await uploadFile(fetchedSessionCode, item);
        videoInfo['braintrust'] = null;
      }
    }
    videoInfo['asyncExperienceName'] = item.title;
    videoInfo['asyncFileName'] = item.thumbnail;
    videoInfo['item'] = item.subcategory;
    videoInfo['content'] = item.category;

    const videoInfoReq = {
      user_id: loginUserData.user_id,
      preference_id: userPreferences.pickvideoinfo.id,
      preference_name: 'PICKVIDEOINFO',
      preference_information: JSON.stringify(videoInfo),
    };
    dispatch(updateCreatorOnboarding(apolloClient.client, videoInfoReq));

    if (Number(activepage.value) < 10) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '10',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));
    }

    dispatch(moveNextPage(10))
  };

  const uploadFile = async (sCode: string, item: any) => {
    const payload = {
      file: item.streamType && item.streamType === "VDO" ? " " : null,
      fileName: '',
      streamType: item.streamType,
      stimulusType: item.stimulusType,
      sessionCode: sCode,
      sortOrder: "1",
      tenantId: loginUserData.customer_id,
      stimulusAlias: item.title,
      stimulusDescription: item.url,
      operation: item.streamType && item.streamType === "VDO" ? "COPY" : "",
      sourceId: item.sourceId && item.streamType && item.streamType === "VDO" ? item.sourceId : ""
    };
    setLoading(true);
    try {
      await handleCopyFile(payload);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className={classes.title}>
        Welcome to Module 2, where you’ll measure your first experience!
      </div>
      <div className={classes.subTitle}>
        First, pick a video ad to measure:
      </div>

      <Grid container justifyContent={'center'}>
        {braintrustList ? <Grid item lg={12} md={12} sm={12} container direction={width < 600 ? 'column' : 'row'}>
          {
            selectExperiences.map((item: any, index: number) => (
              <Grid
                className={clsx(classes.item)}
                key={index}
                onClick={() => goNextPage(item)}
                item
                lg={6} md={6} sm={6}
                onMouseOver={() => setHoverIndex(index)}
                onMouseOut={() => setHoverIndex(-1)}
              >
                <img
                  className={hoverIndex === index ? clsx(classes.img, classes.youtubeHover) : classes.img}
                  src={item.thumbnail}
                  alt={'img'}
                />
                <span className={classes.itemTitle}>{item.title}</span>
              </Grid>
            ))
          }
        </Grid> :
          <Loading style={{ width: 70, height: 70 }} />
        }
      </Grid>
      <BackDropAnalyzeLoading loading={loading} />
    </div>
  )

};

export default Module2Slide1;